import { call, put } from 'redux-saga/effects'

import config from '../../../config'
import { handleUnAuthorizedError } from '../../../utils/saga.util'
import {
  archiveProductSucceed,
  getCompanyProductListSucceed,
  requestFailure
} from '../actions'

export function* archiveProductDetailSaga(
  productApi: {
    archiveProduct: (...args: any[]) => any
    getCompanyProductList: (...args: any[]) => any
  },
  {
    payload: { productId, companyId }
  }: { payload: { productId: string; companyId: string } }
) {
  try {
    yield call(productApi.archiveProduct, productId)
    yield put(archiveProductSucceed())
    const { data } = yield call(
      productApi.getCompanyProductList,
      companyId,
      1,
      config.product.limit,
      'createdTime',
      'desc',
      false
    )
    yield put(getCompanyProductListSucceed(data))
  } catch (e) {
    yield handleUnAuthorizedError(e)
    yield put(requestFailure(e))
  }
}
